exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".componentList[data-v-69fc95a4]{display:block!important}.componentList .componentContent[data-v-69fc95a4]{margin-bottom:-10px}.supportDocs[data-v-69fc95a4]{cursor:pointer}.hintIcon[data-v-69fc95a4]{margin-right:10px!important}.hintSideBar[data-v-69fc95a4]{height:calc(100vh - 48px)!important;z-index:1002;margin-top:48px}.listContainer[data-v-69fc95a4]{max-height:calc(100vh - 109px);overflow-y:auto}.helpPageLink[data-v-69fc95a4]{position:absolute;bottom:5px}", ""]);

// exports
